export const SPROUT_QA_SIMULATION_RESOURCE_ID = 'sprout-qa-simulation';
